export const CHANGE_ORDER_QUOTES_REQUEST_MODAL_SET =
  'CHANGE_ORDER_QUOTES_REQUEST_MODAL_SET';
export const CHANGE_ORDER_QUOTES_REQUEST_CONFIRMATION_SET =
  'CHANGE_ORDER_QUOTES_REQUEST_CONFIRMATION_SET';
export const CHANGE_ORDER_QUOTES_SELECT = 'CHANGE_ORDER_QUOTES_SELECT';
export const CHANGE_ORDER_QUOTE_DETAILS_MODAL_CLOSE =
  'CHANGE_ORDER_QUOTE_DETAILS_MODAL_CLOSE';
